"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortal = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var usePortal = function usePortal() {
  var appendEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _appendEl$current;
    var el = (_appendEl$current = appendEl.current) !== null && _appendEl$current !== void 0 ? _appendEl$current : document.createElement("div");
    appendEl.current = el;
    document.body.appendChild(el);
    return function () {
      try {
        document.body.removeChild(el);
      } catch (e) {
        // Ignore
      }
    };
  }, []);
  var createPortal = (0, _react.useCallback)(function (children) {
    var _appendEl$current2;
    if (typeof window === "undefined") return null;

    // May execute before effect runs and appendEl is set
    var el = (_appendEl$current2 = appendEl.current) !== null && _appendEl$current2 !== void 0 ? _appendEl$current2 : document.createElement("div");
    appendEl.current = el;
    return /*#__PURE__*/(0, _reactDom.createPortal)(children, el);
  }, []);
  return {
    createPortal: createPortal
  };
};
exports.usePortal = usePortal;
//# sourceMappingURL=usePortal.js.map